import React, { Component } from 'react';
import withAppLayout from '../components/appLayout';
import SingleFundPageNew from './single-fund-new';

interface Props {
  selectedFund: any;
  url: any;
  fundData: any;
  statusCode: number;
  userInfo: any;
  entity: any;
  hasUserInvestedInProduct: boolean;
}

class SingleFundPage extends Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  public render() {
    const { statusCode, selectedFund, url } = this.props;

    if ((statusCode && statusCode === 404) || !selectedFund) {
      const { query = {} } = url || {};
      if (query && query.amcSlug && query.fundSlug) {
        url.push(`/mutual-funds/${query.amcSlug}`);
      } else {
        url.push('/mutual-funds');
      }
      return null;
    }

    return (
      <div>
        <SingleFundPageNew {...this.props} />
      </div>
    );
  }
}

export default withAppLayout(
  { hideDefaultCanonical: true, applyV2Styles: false },
  SingleFundPage
);



// WEBPACK FOOTER //
// ./pages/single-fund.tsx